import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const LandingPage = lazy(() => import('@features/landing/LandingPage'));
const LandingTestingPage = lazy(() => import('@features/landing/LandingTestingPage'));
const LandingTestingResultPage = lazy(() => import('@features/landing/LandingTestingResult'));

const LandingRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/testing" element={<LandingTestingPage />} />
      <Route path="/testing-result" element={<LandingTestingResultPage />} />
    </Routes>
  );
};

export default LandingRoutes;
